import { breakpointsVuetify } from '@vueuse/core'

// @ts-expect-error There won't be declaration file for it
import { VIcon } from 'vuetify/lib/components/VIcon/VIcon'

// ❗ Logo SVG must be imported with ?raw suffix
import logo from '@/assets/logo.svg?raw'
import logoC from '@/assets/logoC.svg?raw'
import { defineThemeConfig } from '@core'
import { RouteTransitions, Skins } from '@core/enums'
import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums'

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    title: 'Yupana',
    logo: h('div', { innerHTML: logo, class: 'text-primary', style: 'line-height:0;' }),
    logoC: h('div', { innerHTML: logoC, class: 'text-primary', style: 'line-height:0;' }),
    contentWidth: ContentWidth.Fluid,
    contentLayoutNav: AppContentLayoutNav.Vertical,
    overlayNavFromBreakpoint: breakpointsVuetify.xs + 16,
    enableI18n: false,
    theme: 'light',
    isRtl: false,
    skin: Skins.Default,
    routeTransition: RouteTransitions.Fade,
    iconRenderer: VIcon,
    appName: 'Yupana', // Will update name in navigation menu (Branding)
  },
  customizer: false,
  enableScrollToTop: true,
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: false,
  },
  footer: { type: 'hidden' },
  verticalNav: {
    isVerticalNavCollapsed: true,
    defaultNavItemIconProps: { icon: 'mdi-circle-outline', size: 10 },
    isVerticalNavSemiDark: false,
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition',
  },
  icons: {
    chevronDown: { icon: 'mdi-chevron-down' },
    chevronRight: { icon: 'mdi-chevron-right', size: 18 },
    close: { icon: 'mdi-close' },
    refresh: { icon: 'mdi-refresh' },
    verticalNavPinned: { icon: 'mdi-record-circle-outline' },
    verticalNavUnPinned: { icon: 'mdi-circle-outline' },
    sectionTitlePlaceholder: { icon: 'mdi-minus' },
  },
})
